// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3027":"e307bb9c","3980":"64d2c7ff"}[chunkId] + ".chunk.css";
};